import { computed, inject, Injectable, signal } from '@angular/core';
import { ViewportChangeService } from '@libs/services/viewport-change';
import { toSignal } from '@angular/core/rxjs-interop';
import { combineLatest, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private viewportService = inject(ViewportChangeService);

  public collapsedState = signal<boolean>(false);
  public isMobileOpened = signal<boolean>(false);

  public isCollapsed = computed(() => {
    return this.collapsedState();
  });

  // collapse exists only starting from tablet, and it is collapsed below desktop-lg
  private allowCollapse = toSignal(
    combineLatest([
      this.viewportService.isMobile(),
      this.viewportService.isDesktopLarge(),
    ]).pipe(
      map(([isMobile, isDesktopLarge]) => {
        if (isMobile) {
          this.collapsedState.set(false);
          return false;
        }
        this.collapsedState.set(!isDesktopLarge);
        return !isDesktopLarge;
      }),
    ),
  );
}
